export default "__VITE_PUBLIC_ASSET__74042d5d__"